class MNewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.cookieName = 'Minimog:newsletter-popup-' + this.dataset.sectionId;
    this.overlay = this.querySelector('[data-newsletter-popup-overlay]');
    this.closeButton = this.querySelector('[data-newsletter-popup-close]');
    this.delay = parseInt(this.dataset.delay, 10) || 0;
    this.reappearDays = parseInt(this.dataset.reappearDays, 10) || 7;
    this.timer = null;

    this.__onKeydown = this.__onKeydown.bind(this);
  }

  connectedCallback() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.dismiss());
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.dismiss());
    }

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', this.__onSectionSelect.bind(this));
      document.addEventListener('shopify:section:deselect', this.__onSectionDeselect.bind(this));
      // In the editor the popup is only shown on demand, so merchants can keep
      // working on the page underneath it.
      if (this.dataset.designMode === 'true') this.open();
      return;
    }

    // The form posts back to the same URL, so re-open to show the result.
    if (this.dataset.forceOpen === 'true') {
      this.open();
      return;
    }

    if (this.dataset.enable !== 'true') return;
    if (this.getCookie(this.cookieName)) return;

    if (this.delay > 0) {
      this.timer = setTimeout(() => this.open(), this.delay * 1000);
    } else {
      this.open();
    }
  }

  disconnectedCallback() {
    if (this.timer) clearTimeout(this.timer);
    document.removeEventListener('keydown', this.__onKeydown);
    if (window.Shopify && Shopify.designMode) {
      document.removeEventListener('shopify:section:select', this.__onSectionSelect.bind(this));
      document.removeEventListener('shopify:section:deselect', this.__onSectionDeselect.bind(this));
    }
  }

  __onSectionSelect(event) {
    if (event.detail.sectionId === this.dataset.sectionId) this.open();
  }

  __onSectionDeselect(event) {
    if (event.detail.sectionId === this.dataset.sectionId && this.dataset.designMode !== 'true') {
      this.close();
    }
  }

  __onKeydown(event) {
    if (event.key === 'Escape') this.dismiss();
  }

  open() {
    this.classList.add('is-open');
    document.addEventListener('keydown', this.__onKeydown);
    // Let the browser paint the display change before transitioning in.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.classList.add('is-visible'));
    });
  }

  close() {
    this.classList.remove('is-visible');
    document.removeEventListener('keydown', this.__onKeydown);
    setTimeout(() => this.classList.remove('is-open'), 300);
  }

  /** Close and remember the choice, so it does not reopen on the next page. */
  dismiss() {
    if (!(window.Shopify && Shopify.designMode)) {
      this.setCookie(this.cookieName, 'dismissed', this.reappearDays);
    }
    this.close();
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : '';
  }

  setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
  }
}

customElements.get('m-newsletter-popup') ||
  customElements.define('m-newsletter-popup', MNewsletterPopup);
